import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pin-info',
  templateUrl: './pin-info.component.html',
  styleUrls: ['./pin-info.component.less']
})
export class PinInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
